/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_More_SaveInputs */

const en_views_more_save = /** @type {(inputs: Views_More_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More save options`)
};

const de_views_more_save = /** @type {(inputs: Views_More_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Speicheroptionen`)
};

/**
* | output |
* | --- |
* | "More save options" |
*
* @param {Views_More_SaveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_more_save = /** @type {((inputs?: Views_More_SaveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_More_SaveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_more_save(inputs)
	return en_views_more_save(inputs)
});